import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import { ClaimCyclePivotReportLineContainerModel, ClaimCycleAuditTrailContainer } from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ClaimCyclePivotReportLineService extends BaseApiTemplateService<ClaimCyclePivotReportLineContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pivot-report-lines/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pivot-report-lines/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pivot-report-lines/backoffice-ep';

    this.httpClient = http;
  }

  generatePivotReportLines(claimCycleGuid: any, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pivot-report-lines/generation/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pivot-report-lines/generation/backoffice-ep';
    }

    return this.httpClient.post(url, claimCycleGuid, this.getHttpHeader(visa));
  }

  generatePivotReportLinesForAll(body: any, visa: ApiVisa): Observable<BasicApiResponseModel<ClaimCyclePivotReportLineContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pivot-report-lines/generation/multiple-companies/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pivot-report-lines/generation/multiple-companies/backoffice-ep';
    }

    return this.httpClient.post<BasicApiResponseModel<ClaimCyclePivotReportLineContainerModel>>(url, body, this.getHttpHeader(visa));
  }

  auditTrailExport(body: any, apiVisa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pivot-report-lines/audit-trail-export/backoffice-ep';
    if (apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pivot-report-lines/audit-trail-export/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<ClaimCycleAuditTrailContainer>>(url, body, this.getHttpHeader(apiVisa));
  }

  auditTrailExportMultipleCompanies(body: any, apiVisa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pivot-report-lines/multiple-companies/audit-trail-export/backoffice-ep';
    if (apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pivot-report-lines/multiple-companies/audit-trail-export/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<ClaimCycleAuditTrailContainer>>(url, body, this.getHttpHeader(apiVisa));
  }
}
